import api from "@/config/axios";

const pathSys = "system/";
const pathCont = "content/";

export default {
  obtenerInformativos(accion) {
    return api.get(`${pathSys}getSystemInformatives/${accion}`);
  },
  obtenerParametros() {
    return api.get(`${pathSys}getSystemParameters/`);
  },
  obtenerParametrosGenerales() {
    return api.get(`${pathCont}getTicketParams`);
  },
};
